// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__16R4c","title":"AfterFrontImage_title__1MQgz"};